import { combineReducers } from '@reduxjs/toolkit';
import generalDataSlice from './features/generalData/generalDataSlice';
import { GeneralDataState } from './features/generalData/generalDataTypes';

export interface AppState {
  generalData: GeneralDataState;
}

export const rootReducer = combineReducers<AppState>({
  generalData: generalDataSlice.reducer,
});
